import { styled } from "@mui/system";
import { Stack } from "@mui/material";
const { Box, Typography } = require("@mui/material");

export const StyledNavBox = styled(Box)(({ theme }) => ({
  position: "relative",
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
  cursor: "pointer",
}));

export const StyledNavLink = styled(Typography)({
  textDecoration: "none",
});

export const StyledDropdownBox = styled(Box)(({ theme, isVisible }) => ({
  borderRadius: theme.borders.borderRadius.md,
  display: isVisible ? "block" : "none",
  position: "absolute",
  top: "150%",
  left: 0,
  backgroundColor: "white",
  color: "black",
  padding: theme.spacing(2),
  zIndex: 1,
  boxShadow: theme.shadows[2],
  minWidth: "200px",
  "&::before": {
    content: '""',
    position: "absolute",
    top: "-15px",
    left: 0,
    borderWidth: "10px 10px 0 10px",
    borderStyle: "solid",
    borderColor: theme.palette.accent.main + " transparent transparent transparent",
    width: 0,
    height: 0,
  },
}));

export const StyledNavTitle = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  color: theme.palette.primary.main,
  fontWeight: "100%",
  [theme.breakpoints.up("lg")]: {
    fontSize: "16px",
  },
}));

export const StyledCategoryList = styled(Stack)(({ theme, hasSubmenu, hoveredSubmenu }) => ({
  minWidth: 200,
  borderRight: hoveredSubmenu !== null && hasSubmenu ? `1px solid ${theme.palette.grey[300]}` : "none",
  paddingRight: hoveredSubmenu !== null && hasSubmenu ? theme.spacing(3) : 0,
}));

export const StyledCategoryItem = styled(Typography)(({ theme, isHovered }) => ({
  paddingTop: theme.spacing(0.625),
  paddingBottom: theme.spacing(0.625),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  cursor: "pointer",
  backgroundColor: isHovered ? theme.palette.grey[100] : "transparent",
  borderRadius: theme.borders.borderRadius.md,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  textDecoration: "none",
  color: theme.palette.text.main,
  transition: "all 0.2s ease",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "semi-bold",
  "&:hover": {
    backgroundColor: theme.palette.grey[100],
  },
}));

export const StyledSubmenuArrow = styled(Typography)(({ theme }) => ({
  fontSize: "20px",
  color: theme.palette.grey[500],
  lineHeight: 1,
  marginLeft: theme.spacing(2),
}));

export const StyledSubmenuList = styled(Stack)({
  minWidth: 200,
});

export const StyledSubmenuItem = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(0.625),
  paddingBottom: theme.spacing(0.625),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  borderRadius: theme.borders.borderRadius.md,
  textDecoration: "none",
  color: theme.palette.text.main,
  display: "block",
  transition: "all 0.2s ease",
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.dark.main,
  },
}));

export const StyledSingleColumnItem = styled(Typography)(({ theme }) => ({
  width: "100%",
  display: "block",
  borderRadius: theme.borders.borderRadius.md,
  textDecoration: "none",
  color: theme.palette.text.main,
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.dark.main,
    "& *": {
      color: theme.palette.dark.main,
    },
  },
}));
